import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Task } from '../../core/models/task.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.component.html',
  styleUrls: ['./task-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class TaskDetailComponent implements OnInit {
  @Input() task: Task | null = null; // Recibir la tarea
  @Output() closeDetail = new EventEmitter<void>(); // Emitir evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emitir evento de cerrar
  }
}
